import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { categoriesApi } from '@/api/categories';
import type { Category } from '@/api/types';

export const categoryKeys = {
  all: ['categories'] as const,
  forCompetition: (competitionId: string) => [...categoryKeys.all, 'competition', competitionId] as const,
};

export function useCategories(competitionId: string | undefined) {
  return useQuery({
    queryKey: categoryKeys.forCompetition(competitionId ?? ''),
    queryFn: () => categoriesApi.listForCompetition(competitionId as string),
    enabled: Boolean(competitionId),
  });
}

export function useCreateCategory(competitionId: string) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (payload: Partial<Category>) =>
      categoriesApi.create({ ...payload, competitionId }),
    onSuccess: () =>
      queryClient.invalidateQueries({ queryKey: categoryKeys.forCompetition(competitionId) }),
  });
}

export function useDeleteCategory(competitionId: string) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => categoriesApi.remove(id),
    onSuccess: () =>
      queryClient.invalidateQueries({ queryKey: categoryKeys.forCompetition(competitionId) }),
  });
}
